module.exports = __webpack_public_path__ + "images/13e268f39662c2ff73510f3f06c54c93.svg";